<template>
    <Form ref="defaultForm" :validation-schema="getSchema(form.complianceType)">
        <!-- v-slot="{ errors }" {{errors}} -->
        <div class="flex items-center  xl:flex-row flex-col gap-3 mb-3">   
            <div class="xl:w-2/3 w-full">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="name" v-model="form.name">
                        <span class="text-xs mb-0" :class="labelClass(field.value, errorMessage)">Name</span>
                        <input @change="vm_modified(true)" v-bind="field" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm text-theme-white" :class="inputClass(field.value, errorMessage)" placeholder="OG Kush" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="xl:w-1/3 w-full">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="brandId" v-model="form.brandId">
                        <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Brand</span>
                        <SelectSearchBrand @change="vm_modified(true)" v-bind="field" :value="field.value" :options="brands" placeholder="Select One" class="relative block rounded bg-gray-black w-full border-none text-sm " />
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="categoryId" v-model="form.categoryId">
                        <label class="text-xs mb-1" :class="labelClass(field.value, errorMessage)">Category</label>
                        <div class="block rounded bg-gray-black w-full text-sm px-1 overflow-hidden">
                        <div class="flex-1 justify-between">
                            <div class="flex flex-row">
                                <span class="mt-2 w-5 h-5 rounded" :style="'background:'+categoryColor+';'" ></span>
                                <select @change="getTaxForSelectedCategory(form.categoryId)" v-bind="field" class="relative left-2 pt-1.5 w-full h-9 bg-gray-black focus:border-0 focus:ring-0 border-0" :class="form.categoryId?'text-white':'text-theme-878686'">
                                    <option value="" disabled>Select One</option>
                                    <template v-for="category in categories" :key="'category-'+category.id">
                                        <option v-if="!category.featured" :value="category.id">
                                            {{category.parent?'&nbsp;&nbsp;&nbsp;':''}}{{category.name}}
                                        </option>
                                    </template>
                                </select>
                            </div>
                        </div>
                        </div>
                        <div v-if="errors.length>0" class="text-sm"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <span class="mb-0 text-xs">Featured Category</span>
                    <select-checkbox @change="vm_modified(true)" v-model="form.featuredCategoryIds" :options="categories.filter(each => each.featured && each.parent==null)" placeholder="Select One" class="block rounded bg-gray-black border-none w-full text-sm " :class="form.featuredCategoryIds?'text-white':'text-theme-878686'" /> 
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="strain" v-model="form.strain" >
                        <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Plant Type</span>
                        <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <select v-else @change="vm_modified(true)" v-bind="field" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider"  :class="form.strain?'text-white':'text-theme-878686'">
                            <option value="">Select One</option>
                            <option v-for="(plantType, ind) in plantTypes" :key="'plant-'+ind" :value="plantType">{{plantType}}</option>
                        </select>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-2/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="licensedProducer" v-model="form.licensedProducer" >
                        <LicenseProducer @change="vm_modified(true)" placeholder="Enter LP here" v-model="form.licensedProducer" iconClass=" mt-3" />
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3" v-if="vg_selectedLocation.id">
                <div class="input-wrapper">
                    <Field name="tax" v-model="form.tax" >
                        <span class="mb-0 text-xs">Tax</span>
                        <select-checkbox @change="vm_modified(true)" v-model="form.tax" :options="taxOptions" placeholder="Tax" class="block rounded bg-gray-black w-full border-none text-sm tracking-wider" :class="form.tax?'text-white':'text-theme-878686'" /> 
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-model="form.sku" v-slot="{field, errors, errorMessage}" name="sku" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">SKU</label>
                        <input :disabled="asn?.sku" @change="vm_modified(true)" v-bind="field" placeholder="GJFKD2342" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="complianceType" v-model="form.complianceType" >
                        <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">Compliance Type</span>
                        <select @change="vm_modified(true)" v-model="form.complianceType" class="block rounded bg-gray-black border-none w-full text-sm " :class="form.complianceType?'text-white':'text-theme-878686'">
                            <option value="" disabled>Select One</option>
                            <option v-for="(compliance, ind) in complianceList" :value="compliance" :key="'compliance-'+ind">{{compliance}}</option>
                        </select>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="concentration_unit" v-model="form.concentration_unit" >
                        <span class="mb-0 text-xs" :class="labelClass(field.value, errorMessage)">THC/CBD Unit</span>
                        <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <select v-else @change="vm_modified(true)" v-bind="field" class="block rounded bg-gray-black w-full border-none text-sm tracking-wider" :class="form.concentration_unit?'text-white':'text-theme-878686'">
                            <option value="">Select One</option>
                            <option value="%">%</option>
                            <option value="mg/g">Mg/g</option>
                            <option value="mg/ml">Mg/Ml</option>
                            <option value="mg">Mg</option>
                            <option value="ml">Ml</option>
                            <option value="mg/bottle">Mg/bottle</option>
                            <option value="mg/pack">Mg/pack</option>
                            <option value="mg/unit">Mg/unit</option>
                        </select>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3" v-if="vg_selectedLocation.id">
            <!-- single thc or range -->
            <div class="w-full xl:w-1/2" :class="(form.thc_cbd_value_type=='single')?'':'hidden'">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="thc" v-model.number="form.thc">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">THC</label>
                        <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">{{form.concentration_unit}}</span>
                            <input @change="vm_modified(true)" :disabled="asn?.sku" v-model.number="form.thc" name="thc" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <!-- cbd is not set or cdb is range -->
            <div class="w-full xl:w-2/3" :class="(!form.thc_cbd_value_type || form.thc_cbd_value_type=='range')?'':'hidden'">
                <div class="input-wrapper">
                    <label class="text-xs">THC</label>
                    <div class="flex">
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="thc_min" v-model.number="form.thc_min">
                                    <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                    <div v-else class="flex flex-row rounded bg-gray-black ">
                                        <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                        <input @change="vm_modified(true)" :disabled="asn?.sku" v-model.number="form.thc_min" name="thc_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                    </div>
                                    <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                    <div v-else class="text-xs">&nbsp;</div>
                                </Field>
                        </div>
                        <span class="flex items-center mx-1">
                            <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                            </svg>
                        </span>
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="thc_max" v-model.number="form.thc_max">
                                <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <div v-else class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                    <input @change="vm_modified(true)" :disabled="asn?.sku" v-model.number="form.thc_max" name="thc_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Single CBD or range -->
            <div  class="w-full xl:w-1/2" :class="(form.thc_cbd_value_type=='single')?'':'hidden'">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="cbd" v-model.number="form.cbd">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">CBD</label>
                        <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">{{form.concentration_unit}}</span>
                            <input @change="vm_modified(true)" :disabled="asn?.sku" v-model.number="form.cbd" name="cbd" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <!-- thc_cbd_value_type is not set or thc_cbd_value_type is range -->
            <div class="w-full xl:w-2/3" :class="(!form.thc_cbd_value_type || form.thc_cbd_value_type=='range')?'':'hidden'">
                <div class="input-wrapper">
                    <label class="text-xs">CBD</label>
                    <div class="flex">
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="cbd_min" v-model.number="form.cbd_min">
                                <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <div v-else class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                    <input @change="vm_modified(true)" :disabled="asn?.sku" v-model.number="form.cbd_min" name="cbd_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-xs" :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                        <span class="flex items-center mx-1">
                            <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                            </svg>
                        </span>
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="cbd_max" v-model.number="form.cbd_max">
                                <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <div v-else class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-1">{{form.concentration_unit}}</span>
                                    <input @change="vm_modified(true)" :disabled="asn?.sku" v-model.number="form.cbd_max" name="cbd_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper w-full">
                    <Field v-slot="{field, errors, errorMessage}" name="totalTerp" v-model="form.totalTerp" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Terps</label>
                        <div v-if="form.complianceType && form.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">%</span>
                            <input @change="vm_modified(true)" :disabled="asn?.sku" v-model="form.totalTerp" name="totalTerp" placeholder="4.0" min="0" class="block tracking-wider border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686 disabled:" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex items-start mb-3">
            <div class="w-full">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="description" v-model="form.description" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Description</label>
                        <textarea @change="vm_modified(true)" v-bind="field" id="message" rows="4" class="block rounded border-none p-2.5 w-full text-sm bg-gray-black placeholder-theme-878686" placeholder=""></textarea>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex items-start mb-3">
            <div class="w-full">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="longDescription" v-model="form.longDescription" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Long Description</label>
                        <textarea @change="vm_modified(true)" v-bind="field" id="message" rows="4" class="block rounded border-none p-2.5 w-full text-sm bg-gray-black placeholder-theme-878686" placeholder=""></textarea>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
    </Form>
    <div class="flex justify-end flex-reverse">
        <button @click="emitter.emit('closeAddEdit')" class="border rounded px-5 py-2 text-grey border-grey">Cancel</button>
        <button @click="emitter.emit('saveEditProduct')" class="uppercase hover:bg-slate-100 px-8 py-2 bg-white rounded ml-3 text-theme-green">save</button>
    </div>
</template>
<script>
import _ from 'lodash'
import Helpers from '@/helpers';
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {Form, Field} from 'vee-validate'
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import SelectSearchBrand from '@/components/form/SelectSearchBrand'
import { ref, defineComponent } from 'vue'
import ProductApi from '@/controllers/BusinessProductApis'
import BusinessCategoryApis from "@/controllers/BusinessCategoryApis";
import { useSnackbar } from "vue3-snackbar"
import StringHelper from '@/helpers/string'
import ObjectHelper from '@/helpers/object'
import ProductHelper from '@/helpers/product'
import BusinessTaxApis from "@/controllers/BusinessTaxApis";
import isEmpty from 'lodash/isEmpty'
import PriceMarkupSettingApis from "@/controllers/LocationMarkupPrice";
import lowerCase from 'lodash/lowerCase'
import LicenseProducer from '@/components/form/LicenseProducer'

export default defineComponent({
    props: [ 'asn', 'fulfillment', 'globalExemptScanner', 'editItem', 'type', 'cannabisProfile', 'pricing', 'categories', 'brands', 'taxes', 'productTax'],
    components: {
        Form,
        Field,
        SelectCheckbox,
        SelectSearchBrand,
        LicenseProducer
    },
    setup() {
        const snackbar = useSnackbar();
        const form = ref({
            name: '',
            brandId: '',
            categoryId: '',
            featuredCategoryIds: [],
            strain: '',
            tax: '',
            complianceType: '',
            stock: '',
            stock_threshold: '',
            sku: '',
            concentration_unit: '',
            description: '',
            longDescription: '',
            thc_cbd_value_type: '',
            thc: '',
            thc_min: '',
            thc_max: '',
            cbd: '',
            cbd_min: '',
            cbd_max: '',
            totalTerp: '',
            caseSize: '',
            licensedProducer: '',
            lotTracking: false,
            exemptFromScanning: false
        })
        const schema = {
            name: 'required',
            strain: 'required',
            complianceType: 'required',
            sku: 'required|min:3|max:100',
            licensedProducer: ''
        }
        const accessorySchema= {
            name: 'required',
            complianceType: 'required',
            sku: 'required|min:3|max:100',
            licensedProducer: ''
        }
        const locationSchema = {
            name: 'required',
            strain: 'required',
            complianceType: 'required',
            sku: 'required|min:3|max:100',
            concentration_unit: 'required',
            thc: 'price',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price',
            cbd_min: 'price',
            cbd_max: 'price',
            totalTerp: 'percentage',
            licensedProducer: ''
        }
        const locationAccessorySchema = {
            name: 'required',
            complianceType: 'required',
            sku: 'required|min:3|max:100',
            thc: 'price',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price',
            cbd_min: 'price',
            cbd_max: 'price',
            licensedProducer: ''
        }

        let complianceList = ['Dried flower','Pre rolled','Extracts ingested','Extracts inhaled','Edibles solids','Edibles non-solids','Topicals','Accessory']
        let plantTypes = ['sativa', 'indica', 'hybrid', 'blend']
        const markupPrices = ref([])
        const markupPercent = ref('')
        const regularPriceModified = ref(false)
        let taxOptions = []

        return {snackbar, form, schema, accessorySchema, locationSchema, locationAccessorySchema, complianceList, plantTypes, taxOptions, markupPrices, markupPercent, regularPriceModified}
    },
    async mounted() {
        if(this.editItem.id){
            ProductHelper.loadProductDataForDefaultForm(this.form, this.editItem)
            ProductHelper.loadCannabisDataForDefaultForm(this.form, this.cannabisProfile)
            ProductHelper.loadPricingDataForDefaultForm(this.form, this.pricing)
            this.form.featuredCategoryIds = await this.getFeaturedCategory(this.editItem.id)

            // //tax
            this.form.tax = this.productTax.map(each => {return each.id})
            this.taxOptions = this.taxes.map(each => {return {id: each.id, name:each.name}})
        }
        if(!isEmpty(this.asn)){
            await this.getMarkupPrices()
            // ProductHelper.loadDataFromAsnForDefaultForm(this.form, this.asn)
        }
        
        this.emitter.on("saveEditProduct", this.submit);
        this.emitter.on("reloadEditCannabis", this.reloadCannabis)
        this.emitter.on("updateLotTracking", this.updateLotTracking);
        this.emitter.on("updateExemptScanning", this.updateExemptScanning);
    },
    unmounted(){
        this.emitter.off("saveEditProduct", this.submit)
        this.emitter.off("reloadEditCannabis", this.reloadCannabis)
        this.emitter.off("updateLotTracking", this.updateLotTracking);
        this.emitter.off("updateExemptScanning", this.updateExemptScanning);
    },
    beforeDestroy() {
        this.emitter.off("saveEditProduct", this.submit)
        this.emitter.off("reloadEditCannabis", this.reloadCannabis)
        this.emitter.off("updateLotTracking", this.updateLotTracking);
        this.emitter.off("updateExemptScanning", this.updateExemptScanning);
    },
    watch: {
        async editItem(item){
            if(item?.id){
                ProductHelper.loadProductDataForDefaultForm(this.form, item)
                ProductHelper.loadCannabisDataForDefaultForm(this.form, this.cannabisProfile)
                ProductHelper.loadPricingDataForDefaultForm(this.form, this.pricing)
                this.form.featuredCategoryIds = await this.getFeaturedCategory(item.id)
                this.form.tax = (this.productTax || []).map(each => {return each.id})
            }
            if(!isEmpty(this.asn)){
                //ProductHelper.loadDataFromAsnForDefaultForm(this.form, this.asn)
            }
        },
        cannabisProfile(){
            ProductHelper.loadCannabisDataForDefaultForm(this.form, this.cannabisProfile)
        },
        pricing(){
            ProductHelper.loadPricingDataForDefaultForm(this.form, this.pricing)
        },
        productTax(){
            let self =this
            setTimeout(function(){
                self.form.tax = self.productTax.map(each => {return each.id})
            }, 700)
        },
        taxes(){
            this.taxOptions = this.taxes.map(each => {return {id: each.id, name:each.name}})
        },
    },
    computed: {
        categoryColor: function() {
            if(this.form.categoryId){
                let currentCategory = this.categories.filter(each => each.id == this.form.categoryId)
                if(currentCategory[0]?.posColour)
                    return currentCategory[0].posColour
                else
                    return 'black'
            }else{
                return 'black'
            }
        },
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        getMarkupPercent(){
            if(this.regularPriceModified){
                this.markupPercent = ((this.form.price-this.form.cost)/(this.form.cost*0.01)).toFixed(2)
            }
        },
        async getMarkupPrices(){
            let res = await PriceMarkupSettingApis.fetchByLocationId(this.vg_selectedLocation.id)
            if(this.asn){
                this.markupPrices = ObjectHelper.getDefaultMarkup(res?.data?.payload)
            }else{
                if(res.status==200){
                    this.markupPrices = res.data.payload
                }
            }
        },
        async reloadCannabis(){
            if(this.vg_selectedLocation.id){
                let cannabisProfile = await this.getCannabisProfile(this.editItem.id)
                if(cannabisProfile){
                    ProductHelper.loadCannabisDataForDefaultForm(this.form, cannabisProfile)
                }
            }
        },
        updateLotTracking(val){
            this.form.lotTracking = val
        },
        updateExemptScanning(val){
            this.form.exemptFromScanning = val
            this.vm_modified(true)
        },
        async getCannabisProfile(productId){
            let res = await ProductApi.fetchCannabisProfile(productId, this.vg_selectedLocation.id)
            if(res.data?.payload){
                return res.data.payload
            }
        },
        async getPricing(productId){
            let data = {locationId: this.vg_selectedLocation.id, productIds:[productId]}
            let res = await ProductApi.fetchPricingByProductId(data)
            if(res.data?.payload[0]){
                return res.data.payload[0]
            }
        },
        getSchema(type){
            if(this.vg_selectedLocation.id){
                if(type=='Accessory'){
                    return this.locationAccessorySchema
                }else{
                    return this.locationSchema
                }
            }else{
                if(type=='Accessory'){
                    return this.accessorySchema
                }else{
                    return this.schema
                }
            }
        },
        async getFeaturedCategory(productId){
            let res = await ProductApi.fetchFeaturedCategory(productId)
            if(res?.data?.payload){
                return res.data.payload.map(each => each.id)
            }
        },
        labelClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }else if(value){
                return 'text-theme-green'
            }
        },
        inputClass(value, error){
            if(value && error){
                return 'border-theme-red'
            }else if(error){
                return 'border-theme-orange'
            }else if(value){
                return 'border-theme-green'
            }
        },
        errorClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }
        },
        async getLotTrackingForSelectedCategory(catId){
            let category = await BusinessCategoryApis.getCategoryById(catId)
            if(category.status==200 && category.data.payload){
                this.$emit('updateAsnLotTracking', category.data.payload.lotTracking)
            }else{
                this.$emit('updateAsnLotTracking', false)
            }
        },
        async getTaxForSelectedCategory(catId){
            if(catId){
                this.vm_modified(true)
                if(this.vg_selectedLocation.id){
                    this.emitter.emit('toggleSave', true)
                    this.emitter.emit('toggleVariant', true)
                    if(this.asn){
                        this.getLotTrackingForSelectedCategory(catId)
                    }
                    let categoryTax = await BusinessTaxApis.getCategoryTaxes(catId, this.vg_selectedLocation.id)
                    if(categoryTax.status==200 && categoryTax.data.payload){
                        this.form.tax = categoryTax.data.payload.map(each => each.id)
                    }else{
                        this.form.tax = []
                    }
                    this.emitter.emit('toggleSave', false)
                    this.emitter.emit('toggleVariant', false)
                }
            }else{
                this.form.tax = []
            }
        },
        calculatePrice(val){
            if(!this.editItem.complianceType) return
            let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===lowerCase(this.editItem.complianceType.replace(/\s/gi, '')))
            if(currentMarkupPrice && currentMarkupPrice.status && currentMarkupPrice.markupPercentage){
                // this.markupPercent = currentMarkupPrice.markupPercentage
                let value = parseFloat(val)
                this.currentMarkupPrice = parseInt(currentMarkupPrice.markupPercentage)

                this.markupType = currentMarkupPrice.markupType
                let result = 0
                let decimal = 0
                if(currentMarkupPrice.markupType==='margin'){
                    let marginVal = 1-this.currentMarkupPrice/100
                    result = parseFloat(value)/marginVal
                    return result?result.toFixed(2):''
                }else{
                    result = parseFloat(value)+(val*this.currentMarkupPrice/100)
                    decimal = (result%1).toFixed(2)
                    if(decimal>0){
                        return result?+parseInt(result)+0.99:''
                    }else{
                        return result?+result.toFixed(2):''
                    }
                }
            }else if(this.asn){
                return this.asn.cost
            }else{
                return 0
            }
        },
        async submit(){
            let validationResult = await this.$refs.defaultForm?.validate()
            let hasBatchLot = true
            let hasPackagedOn = true
            let hasPrice = true
            let price
            if(this.asn?.sku){
                if(!this.asn.cost){
                    this.snackbar.add({
                        type: 'info',
                        text: "Price is required",
                        duration: 3000,
                    })
                    hasPrice = false
                }else{
                    price = this.calculatePrice(this.asn.cost)
                    if(price===0){
                        this.snackbar.add({
                            type: 'info',
                            text: "Price is required",
                            duration: 3000,
                        })
                        hasPrice = false
                    }
                }
            }

            if(validationResult?.valid && hasBatchLot && hasPackagedOn && hasPrice){
                if(this.form.complianceType?.toLowerCase()=='accessory'){
                    this.editItem.productFamily = 'retail'
                }else{
                    this.editItem.productFamily = 'cannabis'
                }
                let productData = {...this.editItem, ...this.form}
                if(productData.barcode===''){
                    productData.barcode = null
                }

                let cannabisProfileData = {
                    locationId: this.vg_selectedLocation.id,
                    thc_cbd_value_type: this.form.thc_cbd_value_type?this.form.thc_cbd_value_type:'single',
                    concentration_unit: this.form.concentration_unit,
                    thc: parseFloat(this.form.thc),
                    cbd: parseFloat(this.form.cbd),
                    thc_min: parseFloat(this.form.thc_min),
                    thc_max: parseFloat(this.form.thc_max),
                    cbd_min: parseFloat(this.form.cbd_min),
                    cbd_max: parseFloat(this.form.cbd_max),
                    totalTerp: parseFloat(this.form.totalTerp)
                }

                let productPricingData = {
                    locationId: this.vg_selectedLocation.id,
                    cost: this.pricing.cost?parseFloat(this.pricing.cost):0,
                    price:  this.pricing.cost?parseFloat(this.pricing.price):0,
                    sale_price: this.pricing.cost?parseFloat(this.pricing.price):0,
                    stock: parseInt(this.form.stock) || 0,
                }
                if(this.asn?.sku && isEmpty(this.pricing)){
                    productPricingData.cost = this.asn.cost
                    productPricingData.price = price
                    productPricingData.sale_price = price
                }
                this.vm_spinner(true)
                if(this.asn?.sku){
                    productData.sku = this.editItem.sku
                    await this.asnSaveProduct(this.editItem, productData, cannabisProfileData, productPricingData)
                }
                this.saveProduct(productData, cannabisProfileData, productPricingData)
            }
        },
        async asnSaveProduct(variant, productData,cannabisProfileData,productPricingData){
            let data = {
                product:{
                    name:this.form.name,
                    locationId:this.vg_selectedLocation.id,
                    categoryId:this.form.categoryId,
                    brandId:this.form.brandId,
                    description:this.form.description,
                    longDescription: this.form.longDescription,
                    productFamily:productData.productFamily,
                    complianceType:this.form.complianceType,
                    strain:this.form.strain,
                    concentration_unit:this.form.concentration_unit,
                    supplierId:productData.supplierId,
                    sku: this.asn.sku,
                    barcode: this.asn.productGtin,
                    variantName: this.asn?.product?.variantName,
                    dryCannabisEquivalency:this.asn?.product?.dryCannabisEquivalency,
                    retired:productData.retired,
                    lotTracking:this.form.lotTracking,
                    exemptFromScanning: this.form.exemptFromScanning,
                    caseSize:productData.caseSize,
                    licensedProducer:this.form.licensedProducer,
                    purchaseOrderItemId:this.asn.id
                },
                cannabisProfile: {
                    locationId:this.vg_selectedLocation.id,
                    thc:parseFloat(this.asn.thc),
                    thc_min:parseFloat(this.form.thc_min),
                    thc_max:parseFloat(this.form.thc_max),
                    cbd:parseFloat(this.asn.cbd),
                    cbd_min:parseFloat(this.form.cbd_min),
                    cbd_max:parseFloat(this.form.cbd_max),
                    totalTerp:parseFloat(this.asn.totalTerp),
                    fullfillmentTime:this.asn.fulfillment??''
                }
            }
            let res = await ProductApi.addOrUpdatePurchaseOrderItem(data)
            if(res.status!==200 && res.status!==201){
                this.snackbar.add({
                    type: 'info',
                    text: Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
            }
        },
        async saveProduct(productData, cannabisProfileData, productPricingData){
            let res = await ProductApi.editProduct(this.editItem.id, ObjectHelper.emptyStringToNull(productData))
            if(this.vg_selectedLocation.id){
                productPricingData.productId = this.editItem.id

                // create or update
                await ProductApi.updateCannabisProfile(this.editItem.id, cannabisProfileData)

                // add and remove taxes
                let variantIds = [this.editItem.id, ...this.editItem.variants.map(each => each.id)]
                await this.addOrRemoveProductTax(variantIds, this.productTax, this.form.tax)

                // add featured category
                let featuredData = {
                    locationId: this.vg_selectedLocation.id,
                    categoryIds: this.form.featuredCategoryIds
                }
                await ProductApi.setFeaturedCategory(this.editItem.id, featuredData)
                
            }
            this.vm_spinner(false)
            this.snackbar.add({
                type: 'info',
                text: res.status == 200 ? "Product updated successfully." : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            if(res.status==200){
                this.vm_modified(false)
                if(this.asn?.sku){
                    // for closing product from list
                    this.emitter.emit("added", this.asn)
                    this.emitter.emit("reloadAddAsnList")
                }else{
                    this.emitter.emit("reloadProductList", this.editItem.id)
                    this.emitter.emit("reloadProduct", this.editItem.id)
                }
            }
        },
        async addOrRemoveProductTax(productIds, productTax, formTax){
            // add tax
            let preUpdatedTaxes = productTax.map(each => {return each.id})
            let removed = _.difference(preUpdatedTaxes, formTax)
            let added = _.difference(formTax, preUpdatedTaxes)

            for(let i=0; i<removed.length; i++){
                await ProductApi.removeProductTax({locationId: this.vg_selectedLocation.id, productIds: productIds, taxId: removed[i]})
            }

            for(let j=0; j<added.length; j++){
                await ProductApi.addProductTax({locationId: this.vg_selectedLocation.id, productIds: productIds, taxId: added[j]})
            }
            
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner',
            vm_modified: 'modifiedForm/mutateStatus'
        })
     }
})
</script>
